<template>
  <section class="chapter-3">
    <div class="bg-red chapter-3-panel-1">
      <FlexWrap>
        <div class="container">
          <header>
            <Year class="year">1896</Year>
            <Title>Te veel gevraagd</Title>
          </header>
          <Content class="content">
            <p>Aan het einde van de negentiende eeuw veranderde de wereld heel snel. Meer mensen gingen naar school, kranten werden goedkoper en daarmee werd de wereld een stukje kleiner. Ook kwamen er organisaties die streden voor algemeen kiesrecht en vrouwenkiesrecht. Kiesrecht werd een hot topic, ook in de politiek.</p>
          </Content>
          <Posters>
            <p>Dingen veranderden nu écht. In 1896 kwam er een nieuwe kieswet, waardoor er veel meer mensen mochten stemmen dan eerst.</p>
          </Posters>
        </div>
      </FlexWrap>
    </div>
    <VotingCheck />
    <div class="bg-white chapter-3-panel-2">
      <div class="container">
        <Content>
          <p>Wat hebben huur, salaris, spaargeld en studie te maken met verkiezingen?</p>
          <p>Veel.</p>
          <p>Voortaan speelde niet meer alleen mee hoeveel belasting je betaalde. Deze vier andere ‘kenmerken van geschiktheid’ kwamen erbij.</p>
          <p>Met een bepaald minimum aan huur, spaargeld, salaris of opleiding mocht je voortaan ook stemmen.</p>
        </Content>
      </div>
    </div>
    <VotingPercentage />
    <div id="after-voting-percentage" class="bg-white chapter-3-panel-3">
      <FlexWrap>
        <div class="container">
          <Content>
            <p>De meeste mannen die gingen stemmen, deden dat dus nog gewoon omdat ze genoeg belasting betaalden. Als je op basis van je huur, salaris, spaargeld of studie mocht stemmen, moest je namelijk zelf je stembiljet aanvragen. Daarvoor moest je allerlei bewijsstukken aanleveren. En blijkbaar was dat voor veel mannen te veel gevraagd.</p>
            <p>De minister van Binnenlandse Zaken noemde het trouwens ‘heel schraal’ dat er maar zo weinig nieuwe kiezers gingen stemmen. En deze adviescommissie vond het nieuwe systeem sowieso niks.</p>
          </Content>
          <Chat />
          <Accordion track="accordion-huur-salaris-spaargeld-en-studie">
            <template slot="title">Huur, salaris, spaargeld en studie</template>
            <template slot="explanation">
              <p>Wanneer mocht je nou eigenlijk precies stemmen? Laten we de vier nieuwe groepen kiezers even langslopen.</p>
              <h3>Loonkiezers</h3>
              <p>Je hoorde bij deze groep als je een bepaald bedrag aan salaris of pensioen ontving. Dat varieerde van 46 gulden per maand in Amsterdam en Rotterdam tot 23 gulden in kleinere gemeenten. Als we kijken naar hoeveel loonkiezers zich hadden geregistreerd, zouden we nu uitgaan van een inkomensgrens van ongeveer 55.000 euro per jaar.</p>
              <h3>Huurkiezers</h3>
              <p>Betaalde je maandelijks minstens 3,20 tot 10 gulden aan huur (afhankelijk van je woonplaats), dan mocht je stemmen. Dat lijkt een klein bedrag, maar de prijzen van toen zijn niet te vergelijken met nu. Een gemiddeld arbeidersgezin in de stad gaf in 1896 iedere maand zo’n 52 gulden uit, onder andere aan eten, zeep, kleding en dus ook aan huur.</p>
              <h3>Spaarkiezers</h3>
              <p>Deze groep kiezers moest minstens 50 gulden op een spaarrekening hebben staan. Dat waren er maar heel weinig. Nu zou het dus gaan om de mensen met de best gespekte spaarrekeningen.</p>
              <h3>Examenkiezers</h3>
              <p>Zij hadden voor hun beroep een bepaald diploma nodig, zoals kandidaat-notarissen, gepromoveerden, onderwijzers, artsen en apothekers. Het idee was dat hun inkomen uiteindelijk zo hoog zou zijn, dat ze toch wel mochten stemmen op basis van belastingen of salaris.</p>
              <p>De nieuwe groep kiezers was heel erg klein. In 1901 bestond iets meer dan 7 procent van de kiesgerechtigden uit huur-, loon-, spaar- en examenkiezers.</p>
              <p>In de nieuwe kieswet van 1896 werden nog twee dingen ingevoerd die we nu als vanzelfsprekend beschouwen. Het stemhokje bijvoorbeeld. Daarmee kwam een einde aan de situatie dat mannen thuis hun stembiljet invulden en dat op het stembureau alleen nog maar in de bus hoefden te gooien. Een andere vernieuwing was dat je niet meer zomaar op iedereen kon stemmen. Mensen die zich verkiesbaar wilden stellen, moesten zich van tevoren opgeven.</p>
            </template>
          </Accordion>
        </div>
      </FlexWrap>
    </div>
  </section>
</template>

<script>
import { Year, Title, Content, FlexWrap } from '@/components/chapter'
import { chapterMixin } from '@/mixins'
import Posters from './Posters'
import VotingCheck from './voting-check'
import VotingPercentage from './VotingPercentage'
import Accordion from '@/components/Accordion'
import Chat from './Chat'

export default {
  name: 'Chapter3',
  mixins: [chapterMixin],
  components: {
    Year,
    Title,
    Content,
    Posters,
    VotingCheck,
    VotingPercentage,
    Accordion,
    FlexWrap,
    Chat
  }
}
</script>

<style lang="scss" scoped>
.content {
  position: relative;
  z-index: 2;
}

.chapter-3-panel-2 {
  padding-top: 100px;
  padding-bottom: 100px;

  @media (min-width: 768px) {
    padding-top: 150px;
    padding-bottom: 150px;
  }
}

.year {
  color: white;
}
</style>
